import { makeStyles } from "@mui/styles";

const goToTopButtonStyle=makeStyles((theme)=>({
    topButton:{ 
        width:"44px",
        height:"44px",
        borderRadius:"50%",
        backgroundColor:"#f85a40",
        display:"flex",
        justifyContent:"center",
        alignItems:"center",
        position:"fixed",
        right:"15px",
        bottom:"100px",
        transition:"all 0.4s",
        cursor:"pointer",
        "&.MuiBox-root .MuiSvgIcon-root":{
            color:"#fff !important"
        }
    }
}))

export default goToTopButtonStyle;
